import { Validators } from "@angular/forms";

export const STUDENT_LEDGER_CONTROLS = {
    programaId                  :   [, {updateOn: 'change' }],
    periodoId                   :   [, {updateOn: 'change' }],
};
